{
  "LinkInput_Title": "Title",
  "LinkInput_URL": "URL",
  "LinkInput_Target": "Target",
  "LinkInput_NewTab": "Open in New Tab",
  "LinkInput_CurrentTab": "Open in Current Tab",
  "NAME": "LinkInputLanguage"
}